// extracted by mini-css-extract-plugin
export var productImage = "_nn-1";
export var viewLink = "_nn-2";
export var wishlistItem = "_nn-0";